class Constants {
    public static lightBlue: string = '#487CEF';
    public static darkBlue: string = '#001F4E';
    public static blue: string = '#0751F4';
    public static grey: string = '#FFFFFF';
    public static green: string = '#06C538';
    public static yellow: string ='#F8DE00';
    public static orange: string = '#FF9700';
}

export default Constants;